/**
 * 支払方法変更_受付中返却API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 契約開始受付情報
 */
export interface Sgkd036aReqCtrstrAceptInfo {

    /**
     * 受付番号：半角数字
     */
    aceptNo?: string;
}

